import AppManager from './classes/AppManager.js';
import './controllers/Main.js';
import './controllers/ServiceWorker.js';

import 'material-symbols/outlined.css';
import '@khmyznikov/pwa-install';
import { Toast } from './classes/AppToast';

/**
 * Punto de entrada principal de la aplicación
 */
document.addEventListener('DOMContentLoaded', async () => {
    try {
        const App = new AppManager();
        await App.init();
    } catch (error) {
        console.error('[App] Init Error', error);
        Toast.show('Error al inicializar la aplicación. Por favor, recarga la página o contacta a soporte si el problema persiste.', 'danger', false, () => {
            window.location.reload();
        });
    }
});

window.addEventListener('error', (event) => {
    console.error('[App] Unhandled error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
    });
});

window.addEventListener('unhandledrejection', (event) => {
    console.error('[App] Unhandled promise rejection', {
        reason: event.reason,
        promise: event.promise
    });
});